import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getWebsiteAuditPath } from "@core/schema/paths/getWebsiteAuditPath.js";
import { getWebsitesPath } from "@core/schema/paths/getWebsitesPath.js";

export function getSolutionsHR(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Používání zastaralého HR softwaru",
			desc: `Pracujete s HR softwarem, který je za zenitem, nebo dokonce sázíte jen na tabulky a topíte se v chaosu? Vyvineme pro vás komplexní systém, nebo třeba jen kariérní modul 100% na míru. Poradíme si také s kariérním webem [${getWebsitesPath(tenant)}][[webem]] či s napojením HR softwaru na systémy třetích stran.`,
		},
		{
			title: "Vysoké náklady na inzerci a provoz",
			desc: "Procesy v HR dokážeme optimalizovat tak, abyste zkrátili, a tím pádem i zlevnili proces náboru. Stejně tak vám pomůžeme snížit náklady na inzerci.",
		},
		{
			title: "Ruční zadávání inzerátů na portály",
			desc: "Zadávat stejný inzerát na každý pracovní portál zvlášť? Ale kdeže. Umíme připravit řešení, díky kterému se inzerát automaticky přenese z vašeho webu na další portály.",
		},
		{
			title: "Chaotické vyhodnocování úspěšnosti",
			desc: "Když HR specialisté zveřejňují nabídky na různých portálech, nemají jednotný přehled o úspěchu náboru. Rádi pro vás navrhneme aplikaci, která shromáždí důležitá data ze všech portálů a přehledně je vizualizuje.",
		},
		{
			title: "Propojení HR systému (nejen) s webem",
			desc: "Už žádné ztracené životopisy v přeplněné e-mailové schránce. Postaráme se o propojení vašeho HR systému s webem, e-shopem nebo jinou službou. Když například uchazeč odešle životopis, automaticky se uloží do vašeho systému, přehledně a bez ruční práce.",
		},
		{
			title: "Zdlouhavý onboarding",
			desc: `Papírování a další náležitosti související s onboardingem seberou až desítky hodin, zvlášť ve větších firmách. Pomůžeme vám tyto i další interní procesy [${getWebsiteAuditPath(tenant)}][[optimalizovat]] a zkrátit.`,
		},
	];
}
